import AgencyDetailsSectionSmall from './agency-details-section-small';

export default AgencyDetailsSectionSmall;
